import { Flex } from "@hopper-ui/components";
import { Main } from "@hopper-ui/styled-system";
import { PageLoader } from "@sg-protect/components";
import { type ReactNode, Suspense } from "react";
import { Outlet } from "react-router";
import { useShellTranslation } from "../i18n/i18next.ts";
import { SkipToMain } from "./components/skip-to-main/SkipToMain.tsx";
import { MAIN_CONTENT_ID } from "./constants.ts";

interface PublicLayoutProps {
    children?: ReactNode;
}

export function PublicLayout({ children = <Outlet /> }: PublicLayoutProps) {
    const { t } = useShellTranslation();

    return (
        <>
            <SkipToMain href={`#${MAIN_CONTENT_ID}`} />
            <Flex direction="column">
                <Flex>
                    <Main minHeight="100dvh" id={MAIN_CONTENT_ID} width="100%" minWidth={0}>
                        <Suspense fallback={<PageLoader aria-label={t("Loaders.loadingPage")} />}>{children}</Suspense>
                    </Main>
                </Flex>
            </Flex>
        </>
    );
}
